import React, { memo } from "react";
import PropTypes from "prop-types";
import Select from "react-select";

// eslint-disable-next-line react/display-name
const SingleElement = memo((props) => props.options.label);

const SearchSelect = ({
                        options,
                        isLoading,
                        isClearable,
                        isSearchable,
                        value,
                        onChange,
                        isMulti,
                        isDisabled = false,
                        className = "",
                        placeholder
                      }) => (
  <Select
    className={className}
    classNamePrefix={className}
    options={options}
    isLoading={isLoading}
    isClearable={isClearable}
    isSearchable={isSearchable}
    value={value}
    onChange={onChange}
    isMulti={isMulti}
    optionComponent={SingleElement}
    styles={{
      input: base => ({
        ...base,
        autoComplete: "off"
      }),
      menu: base => ({
        ...base,
        zIndex: 100
      })
    }}
    isDisabled={isDisabled}
    placeholder={placeholder}
  />
);

SearchSelect.propTypes = {
  options: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isMulti: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

SearchSelect.defaultProps = {
  isClearable: true,
  isSearchable: true
};

export default SearchSelect;



// WEBPACK FOOTER //
// ./src/views/lib/components/SearchSelect.js